import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import BOT_USER_AGENTS from '~/const/botUserAgent';

var isSearchEngine = function isSearchEngine(agent) {
  return !!BOT_USER_AGENTS.find(function (bot) {
    return agent && agent.toLowerCase().indexOf(bot.toLowerCase()) !== -1;
  });
};

export default isSearchEngine;